<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">เพิ่มบัญชีทรูมันนี่วอลเล็ท</h2>
			</template>
			<template>
				<form @submit.prevent="confirmOTP">
					<base-input label="เบอร์โทรศัพท์" placeholder="เบอร์โทรศัพท์" v-model="phone" />
					<base-input type="password" label="รหัสผ่าน" placeholder="รหัสผ่าน" v-model="password" />
					<base-input type="password" label="PIN" placeholder="PIN" v-model="pin" />

					<div v-if="otpRef !== ''">
						<base-input label="OTP Reference" v-model="otpRef" readonly />
						<base-input label="OTP Code" placeholder="OTP Code" v-model="otpCode" />
					</div>

					<div class="mt-3">
						<base-button type="primary" :disabled="loading" @click="requestOTP">
							ส่งรหัส OTP
						</base-button>
						<base-button native-type="submit" type="default" :disabled="loading">
							บันทึกข้อมูล
						</base-button>
					</div>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import SettingService from '../../services/setting.service'

export default {
	props: ['open'],
	data() {
		return {
			loading: false,

			phone: '',
			password: '',
			pin: '',
			otpRef: '',
			otpCode: '',
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		requestOTP() {
			this.loading = true
			SettingService.requestTruewalletOTP({
				phone: this.phone,
				password: this.password,
			})
				.then(({ otpRef }) => {
					this.otpRef = otpRef
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
		confirmOTP() {
			this.loading = true
			SettingService.confirmTruewalletOTP({
				phone: this.phone,
				password: this.password,
				pin: this.pin,
				otpRef: this.otpRef,
				otpCode: this.otpCode,
			})
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					// reset to initial state
					this.phone = ''
					this.password = ''
					this.otpRef = ''
					this.otpCode = ''

					this.$emit('close')
					this.$emit('reloadSetting')
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
}
</script>
